import React from "react";
import { Helmet } from "react-helmet";

const Headers = () => {
  return (
    <Helmet>
      <link
        id="faviconApple"
        rel="apple-touch-icon"
        href={`${process.env.PUBLIC_URL}/favicon-prendo.png`}
      />
      <link
        id="favicon"
        rel="icon"
        type="image/png"
        sizes="72x72"
        href={`${process.env.PUBLIC_URL}/favicon-prendo.png`}
      />
      <title>{"Prendo App"}</title>
    </Helmet>
  );
};

export default Headers;
